//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {isNullOrEmpty} from '@nuskin/ns-common-lib';

export default {
  name: 'BundleProducts',
  props: {
    bundle: {
      type: Object,
      default: () => ({})
    },
    market: {
      type: String,
      default: 'US'
    },
    language: {
      type: String,
      default: 'en'
    },
    currency: {
      type: String,
      default: 'USD'
    },
    parentProduct: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    mandatoryProducts() {
      return this.getMandatoryProducts(this.bundle);
    },
    optionalProducts() {
      return this.getOptionalProducts(this.bundle);
    },
    subscriptionPriceLabel() {
      return this.$t('price.subscription');
    },
    configuration() {
      return this.$store.state.nuskin.configuration || {};
    },
    isLoggedIn() {
      return this.$store.state.user.isLoggedIn;
    },
    user() {
      return this.$store.state.user.user;
    },
    showWholeSalePricing() {
      return !!this.$store.getters['nuskin/showWholesalePricing'];
    },
    isWholesale() {
      if (
        !this.isDistributor &&
        !this.isPreferredCustomer &&
        this.showWholeSalePricing &&
        this.isLoggedIn
      ) {
        return false;
      }
      return (
        this.isDistributor ||
        this.isPreferredCustomer ||
        this.showWholeSalePricing
      );
    },
    isDistributor() {
      return this.$store.state.user.isDistributor;
    },
    isPreferredCustomer() {
      return this.$store.state.user.isPreferredCustomer;
    }
  },
  methods: {
    getMandatoryProducts(bundle) {
      if (bundle && bundle.kitProducts && bundle.kitProducts.length > 0) {
        return this.bundle.kitProducts.filter((p) => p.isMandatory === true);
      }
      return null;
    },
    getOptionalProducts(bundle) {
      if (bundle && bundle.kitProducts && bundle.kitProducts.length > 0) {
        return this.bundle.kitProducts.filter((p) => p.isMandatory === false);
      }
      return null;
    },
    bundleUpdate({newSku, oldSku, isRemoveOldSku, isAddNewSku, isOptional}) {
      if (
        !isNullOrEmpty({
          newSku,
          oldSku,
          isRemoveOldSku,
          isAddNewSku,
          isOptional
        })
      ) {
        this.$emit('bundle-update', {
          newSku,
          oldSku,
          isRemoveOldSku,
          isAddNewSku,
          isOptional
        });
      }
    }
  }
};
